import type { FaireProductEntity } from "../../entity_types/product";

export const p_ju2puhctrf: FaireProductEntity = {
  token: "p_ju2puhctrf",
  type: "product",
  name: "Fuck Off Heart Ring | Gold Punk Bold Statement Jewellery",
  brandToken: "b_k8wkg3fhs3",
  brandName: "Gifts From The Crypt",
  imageUrl:
    "https://cdn.faire.com/fastly/c07ddfbe63407a6eadfdc5562536eb7df6aadfba9ff29126b45c2f354dab4d14.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8346a023bf3d3133f802e62276a4d95a1c9f9df5973f2a1f2b9b9443ec3edd44.jpeg",
    "https://cdn.faire.com/fastly/c8fa43b69921e7f37251713c9fce269643aba738ec8a2c72f856a3fc6c393dda.jpeg",
    "https://cdn.faire.com/fastly/57f75909dcc869b163f8d31b5357386a2fd06f3166d2c7fe2e19cda3ca6dfd65.jpeg",
    "https://cdn.faire.com/fastly/efe947333e53842a9d1a2ebdf0477e9ae2db7b018ca3744e7a0dbc691e9a2a59.jpeg",
  ],
  priceDollars: 8.02,
  description:
    '18ct Gold Plated Stainless Steel Heart Ring With Bold "Fuck Off" Inscription\nDurable Non-Tarnish And Water-Resistant Finish\nAvailable In Multiple Sizes – Refer To Size Chart For Best Fit\nUnisex Style Suitable For Both Men And Women\nEdgy Design Perfect For Punk, Alternative, Or Rebellious Fashion\nGreat Gift Idea For Those With Bold Or Humorous Style\nStandout Accessory For Festivals, Nights Out, Or Everyday Wear\nWe Cover US Tariff Fees\n\nTags: fuck off ring, rude heart jewellery, punk band ring, rebellious accessory, gothic style jewellery, bold statement ring, unisex fashion ring, gold plated band, edgy wholesale jewellery, festival jewellery, alternative style ring, trendy heart accessory, rebellious fashion band, humorous statement ring, wholesale punk jewellery, grunge inspired ring, summer bold accessory, unisex gothic jewellery, brat style ring, attitude fashion jewellery',
  tags: [],
  msrpDollars: 26.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:55.305Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
